module.exports = __webpack_public_path__ + "static/media/rouge.d0c6c00c.png";